
<template>
	<div class="spinner">
		<md-empty-state md-rounded :md-icon="currentIcon" md-label="Validating..." md-description="Verifying details.">
		</md-empty-state>
	</div>
</template>

<script>
export default {
  	name: "callback",
  	props: ["auth"],
  	data() {
		return {
			icons: ["autorenew", "sync", "cached"], // List of icons to cycle through
			currentIconIndex: 0,
			interval: null
		};
	},
	computed: {
		currentIcon() {
		return this.icons[this.currentIconIndex];
		}
	},
	mounted() {
		// Cycle through icons every second (adjust the timing as needed)
		this.interval = setInterval(() => {
		this.currentIconIndex =
			(this.currentIconIndex + 1) % this.icons.length;
		}, 1000);

		// Start authentication process
		this.auth.handleAuthentication();
  	},
	beforeDestroy() {
		clearInterval(this.interval);
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue